import script from "./FiltrosAcoes.vue?vue&type=script&setup=true&lang=js"
export * from "./FiltrosAcoes.vue?vue&type=script&setup=true&lang=js"

import "./FiltrosAcoes.vue?vue&type=style&index=0&id=39110bee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39110bee"]])

export default __exports__